import React, { useState } from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import {
  IoLockClosedOutline,
  IoEyeOutline,
  IoEyeOffOutline,
  IoPersonOutline,
} from "react-icons/io5";
import { FaRegEnvelope } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { TbArrowBackUp } from "react-icons/tb";
import apiClient from "../../api/apiClient";
import { handleErrors } from "../../modules/handleErrors";
import { toast } from "react-toastify";
import GoogleSocialLogin from "../../components/Goooglelogin";
import {
  clearStoredReferralId,
  resolveReferralId,
} from "../../utils/referral";
import { trackEvent } from "../../analytics";
import PasswordRequirements from "../../components/PasswordRequirements";
import { getPasswordError } from "../../utils/passwordValidation";

const INPUT_ICON_WRAPPER_CLASS =
  "position-absolute bg-white border-0 px-2 d-flex align-items-center";

const INPUT_ICON_STYLE = {
  zIndex: 10,
  left: 10,
  top: "50%",
  transform: "translateY(-50%)",
};

const INPUT_STYLE = {
  height: "50px",
  fontSize: "13px",
};

const CHECKBOX_ROW_CLASS =
  "form-check d-flex align-items-start gap-2 mb-3 ms-0 ps-0 w-100";

const CHECKBOX_INPUT_STYLE = {
  marginTop: "4px",
  flexShrink: 0,
  width: "16px",
  height: "16px",
};

const CHECKBOX_LABEL_STYLE = {
  fontSize: "12px",
  color: "#6c6c6c",
  lineHeight: 1.55,
  textAlign: "left",
};

const Register = ({ setFormToShow, modalClose }) => {
  const location = useLocation();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const referralId = resolveReferralId(location.search);
  const [RegisterFromData, setRegisterFromData] = useState({
    password: "",
    email: "",
    role: "P",
    full_name: "",
    terms_and_conditions: false,
    important_info: false,
    promotional_emails: false,
  });

  const handleOnchanger = (key, value) => {
    setRegisterFromData((pre) => ({ ...pre, [key]: value }));
  };

  const [passwordTouched, setPasswordTouched] = useState(false);
  const passwordError = getPasswordError(RegisterFromData.password);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (passwordError) {
      setPasswordTouched(true);
      return;
    }

    try {
      setLoader(true);
      const payload = referralId
        ? { ...RegisterFromData, referral_id: referralId }
        : RegisterFromData;
      const response = await apiClient.post("/register/", payload);

      if (!response.ok) return handleErrors(response.data);
      trackEvent("sign_up", {
        method: "email",
        registration_context: "standard",
      });
      clearStoredReferralId();
      toast.success("Check your email to activate your account.");
      modalClose();
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  return (
    <section className="py-3 w-100">
      <div
        className="container overflow-hidden mb-radius px-2 px-sm-3"
        style={{
          backgroundColor: "#CBD5C8",
          borderTopRightRadius: "120px",
          borderBottomLeftRadius: "120px",
        }}
      >
        <div className="row">
          <div className="col-md-6 p-0 position-relative">
            <TbArrowBackUp
              className="position-absolute rounded-5 p-1 bg-white back-arrow"
              style={{
                top: "26px",
                left: "13px",
                fontSize: "30px",
                color: "#000",
                cursor: "pointer",
              }}
              onClick={modalClose}
            />
            <div className="h-100">
              <img
                src="../assets/images/register.png"
                alt="Registration"
                className="img-fluid object-fit-cover w-100 mb-hidden h-100"
                style={{ borderTopRightRadius: "100px" }}
              />
            </div>
          </div>
          <div className="col-lg-6 py-md-0 py-3 d-flex align-items-center col-xl-6 col-md-6 justify-content-center text-center">
            <div
              className="affiliate-form mt-2 mt-md-3 mb-3 pe-md-3 w-100 px-2 px-sm-0"
              style={{ maxWidth: "300px" }}
            >
              <div className="mb-2 w-75 mx-auto">
                <Link
                  to="/"
                  onClick={() => modalClose?.()}
                  className="d-inline-block"
                  aria-label="Go to Mockee home"
                >
                  <img
                    src="../assets/images/mockee-icon.png"
                    alt="Mockee"
                    className="m-auto login-logo"
                  />
                </Link>
              </div>
              <h4 className="mb-2">Welcome to the Mockee</h4>
              <p className="mb-3" style={{ fontSize: "13px" }}>
                Already registered?{" "}
                <Link
                  to="#"
                  onClick={() => setFormToShow("login")}
                  style={{ color: "#000", fontWeight: 600 }}
                >
                  Login
                </Link>
              </p>

              <form onSubmit={handleRegister}>
                <div className="form-group mb-3">
                  <InputGroup className="position-relative">
                    <InputGroup.Text
                      className={INPUT_ICON_WRAPPER_CLASS}
                      style={INPUT_ICON_STYLE}
                    >
                      <FaRegEnvelope style={{ color: "#868B96" }} />
                    </InputGroup.Text>
                    <FormControl
                      required
                      type="email"
                      value={RegisterFromData.email}
                      onChange={(e) => handleOnchanger("email", e.target.value)}
                      id="register-email"
                      placeholder="Email"
                      className="form-control rounded-5 border-0 ps-5 pe-3 py-2 shadow-sm"
                      style={INPUT_STYLE}
                    />
                  </InputGroup>
                </div>

                <div className="form-group mb-3">
                  <InputGroup className="position-relative">
                    <InputGroup.Text
                      className={INPUT_ICON_WRAPPER_CLASS}
                      style={INPUT_ICON_STYLE}
                    >
                      <IoPersonOutline style={{ color: "#868B96" }} />
                    </InputGroup.Text>
                    <FormControl
                      required
                      onChange={(e) =>
                        handleOnchanger("full_name", e.target.value)
                      }
                      value={RegisterFromData.full_name}
                      type="text"
                      id="register-full-name"
                      placeholder="Name"
                      className="form-control rounded-5 border-0 ps-5 pe-3 py-2 shadow-sm"
                      style={INPUT_STYLE}
                    />
                  </InputGroup>
                </div>

                <div className="form-group mb-3">
                  <InputGroup className="position-relative">
                    <InputGroup.Text
                      className={INPUT_ICON_WRAPPER_CLASS}
                      style={INPUT_ICON_STYLE}
                    >
                      <IoLockClosedOutline style={{ color: "#868B96" }} />
                    </InputGroup.Text>
                    <FormControl
                      required
                      onChange={(e) => {
                        setPasswordTouched(true);
                        handleOnchanger("password", e.target.value);
                      }}
                      autoComplete="new-password"
                      value={RegisterFromData.password}
                      type={showPassword ? "text" : "password"}
                      id="register-password"
                      placeholder="Password"
                      className="form-control rounded-5 border-0 shadow-sm ps-5 py-2"
                      style={{
                        ...INPUT_STYLE,
                        paddingRight: "44px",
                      }}
                    />
                    <button
                      type="button"
                      className="position-absolute border-0 bg-transparent d-flex align-items-center justify-content-center"
                      style={{
                        zIndex: 10,
                        right: 12,
                        top: "50%",
                        transform: "translateY(-50%)",
                        padding: 0,
                        color: "#868B96",
                        cursor: "pointer",
                      }}
                      onClick={() => setShowPassword((prev) => !prev)}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      tabIndex={0}
                    >
                      {showPassword ? (
                        <IoEyeOffOutline size={20} />
                      ) : (
                        <IoEyeOutline size={20} />
                      )}
                    </button>
                  </InputGroup>
                  <PasswordRequirements
                    password={RegisterFromData.password}
                    touched={passwordTouched}
                  />
                </div>

                <div className={CHECKBOX_ROW_CLASS}>
                  <input
                    onChange={(e) =>
                      handleOnchanger("promotional_emails", e.target.checked)
                    }
                    checked={RegisterFromData.promotional_emails}
                    type="checkbox"
                    className="form-check-input"
                    id="promotionalEmails"
                    name="promotionalEmails"
                    style={CHECKBOX_INPUT_STYLE}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="promotionalEmails"
                    style={CHECKBOX_LABEL_STYLE}
                  >
                    I agree to receive commercial information about news and
                    commercial offers within the &quot;Mockee&quot; Platform,
                    sent by Kacper Fertacz to the e-mail address I provided. In
                    addition, I declare that I have read the{" "}
                    <a href="/terms-and-conditions">Terms and Conditions</a> and
                    the <a href="/privacy-policy">Privacy Policy</a> and accept
                    their provisions.
                  </label>
                </div>

                <div className={CHECKBOX_ROW_CLASS}>
                  <input
                    required
                    onChange={(e) =>
                      handleOnchanger("terms_and_conditions", e.target.checked)
                    }
                    checked={RegisterFromData.terms_and_conditions}
                    type="checkbox"
                    className="form-check-input"
                    id="termsAndConditions"
                    name="termsAndConditions"
                    style={CHECKBOX_INPUT_STYLE}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="termsAndConditions"
                    style={CHECKBOX_LABEL_STYLE}
                  >
                    I declare that I have read the{" "}
                    <a href="/terms-and-conditions">Terms and Conditions</a> and
                    the Privacy Policy and accept
                    their provisions.
                  </label>
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <button
                    type="submit"
                    className="btn btn-primary border-0 rounded-5"
                    style={{
                      borderRadius: "8px",
                      backgroundColor: "#000",
                      padding: "8px 46px",
                      fontSize: "14px",
                    }}
                  >
                    {loader ? "Register..." : "Register"}
                  </button>
                </div>
              </form>

              <p className="mb-0 mt-3" style={{ fontSize: "12px" }}>
                Or sign in with
              </p>
              <div className="d-flex gap-3 justify-content-center mt-2">
                <GoogleSocialLogin onHide={modalClose} />
              </div>

              <div className="text-center mt-3">
                <p className="mb-0" style={{ fontSize: "13px" }}>
                  Already have an account?{" "}
                  <Link
                    to="#"
                    onClick={() => setFormToShow("login")}
                    style={{ color: "#000", fontSize: "13px", fontWeight: 600 }}
                  >
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
